module.exports = __webpack_public_path__ + "img/profile-bg.35dcf428.png";